import { Attribute, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { SpinnerService } from '../../../services/spinner.service';
import { DownloadService } from '../../../services/download.service';
import { SnackbarService } from '../../../services/snackbar.service';
import {
  FacturaEstadoDTO,
  FacturaPoseedorControllerService,
  FacturaDTO,
  FacturaPoseedorEstadosControllerService,
  FacturaPoseedorFilterDTO,
  PageDTOFacturaDTO,
  PoseedorControllerService,
  PoseedorFilterDTO,
  CvfControllerService,
  FacturaCvfControllerService, FacturaCvfFilterDTO,
  DiccionarioControllerService,
  DiccionarioElementoDTO
} from 'api-rest';
import { HoldersInvoiceNewDocumentDialogComponent } from '../holders-invoice-document-dialog/holders-invoice-document-dialog.component';
import { HoldersInvoiceRejectDialogComponent } from '../holders-invoice-reject-dialog/holders-invoice-reject-dialog.component';
import { HoldersInvoiceAccountingDialogComponent } from '../holders-invoice-accounting-dialog/holders-invoice-accounting-dialog.component';
import { HoldersSelfInvoicesDialogComponent } from '../holders-self-invoices-dialog/holders-self-invoices-dialog.component';
import { DocumentService } from '../../../services/document.service';
import moment from 'moment';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { DatePipe } from '@angular/common';
import { FormatCurrencyPipe } from '../../../share/components/pipe/FormatCurrency.pipe';
import { HoldersCvfInvoicesDialogComponent } from '../holders-cvf-invoices-dialog/holders-cvf-invoices-dialog.component';
import { HoldersCvfInvoiceNewDocumentDialogComponent } from '../holders-cvf-invoice-new-document-dialog/holders-cvf-invoice-new-document-dialog.component';
import { HoldersCvfInvoiceRejectDialogComponent } from '../holders-cvf-invoice-reject-dialog/holders-cvf-invoice-reject-dialog.component';

@Component({
  selector: 'lib-holders-cvf-invoices-search',
  templateUrl: './holders-cvf-invoices-search.component.html',
  styleUrls: ['./holders-cvf-invoices-search.component.scss'],
})
export class HoldersCvfInvoicesSearchComponent implements OnInit {
  pageNumber: number = 0;
  pageSize: number = 25;
  recordsTotal: number = 0;

  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;
  flagSearch: boolean = false;
  totalElements: number = 0;
  totalSearch: number = 0;

  gestorArray: any[] = [];
  estadoArray: any[] = [];

  headArray: any = [
    {
      Head: 'ID. Gestor',
      FieldName: 'gestoresResiduos',
      Attribute: 'id',
    },
    {
      Head: 'Gestor',
      FieldName: 'gestoresResiduos',
      Attribute: 'razonSocial',
    },
    {
      Head: 'Documento',
      FieldName: 'gestoresResiduos',
      Attribute: 'codigoDocumento',
    },
    {
      Head: 'NIMA del gestor',
      FieldName: 'gestoresResiduos',
      Attribute: 'nima',
    },
    {
      Head: 'Número de prefactura',
      FieldName: 'id',
      renderValue: (item: FacturaDTO) =>
        item.fechaAutofactura !== null ? item.id : '',
    },
    {
      Head: 'Fecha de prefactura',
      FieldName: 'fechaMAutofactura',
      OrderValue: (item: any) => {
        if (item.fechaAutofactura) {
          return new Date(item.fechaAutofactura);
        }
        return null;
      },
    },
    {
      Head: 'Número factura gestor ',
      FieldName: 'numeroFactura',
    },
    {
      Head: 'Fecha factura',
      FieldName: 'fechaMFactura',
      OrderValue: (item: any) => {
        if (item.fechaFactura) {
          return new Date(item.fechaFactura);
        }
        return null;
      },
    },
    {
      Head: 'Estado ',
      FieldName: 'estado',
      renderValue: (item: FacturaDTO) =>
        item.estado?.descripcion
    },

    {
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        {
          nameButton: 'delete',
          icon: 'delete',
          toolTip: 'Eliminar registro',
          show: { params: 'canAccessDelete' },
        },
        {
          nameButton: 'view',
          icon: 'open_in_new',
          toolTip: 'Detalle',
          show: { params: 'canAccessView', accion: 'view' }
        },
        {
          nameButton: 'add_invoice',
          icon: 'upload_file',
          toolTip: 'Adjuntar factura',
          show: { params: 'canAccessUpInvoice' },
        },
        {
          nameButton: 'menu',
          array: [
            {
              nameButton: 'download_invoice',
              name: 'Descargar factura',
              show: { params: 'canAccessDonwloadInvoice' },
            },
            {
              nameButton: 'download_self_invoice',
              name: 'Descargar prefactura',
              show: { params: 'canAccessDonwloadSelfInvoice' },
            },
            {
              nameButton: 'accept_invoice',
              name: 'Aceptar factura',
              show: { params: 'canAccessAcceptInvoice' },
            },
            // {
            //   nameButton: 'donwload_pre_invoice-detail',
            //   name: 'Descargar detalle prefacturación',
            //   show: { params: 'canAccessDonwloadSelfInvoice' },
            // },
            // {
            //   nameButton: 'registrate',
            //   name: 'Registrar',
            //   show: { params: 'canAccessRegistrate' },
            // },
            {
              nameButton: 'reject_invoice',
              name: 'Rechazar',
              show: { params: 'canRejectInvoice' },
            },
            {
              nameButton: 'descargarDetalle',
              name: 'Descargar detalle prefactura',
              toolTip: 'Detalle ',
              show: {
                params: 'canAccessView',
                accion: 'descargarDetalle',
              },
            },
          ],
        },
      ],
      permanent: true,
    },
  ];
  gridArray: any[] = [];

  searchForm: FormGroup;
  mostrarFiltros: boolean = true;
  orden: DiccionarioElementoDTO[] = [];
  constructor(
    @Inject('environment') private environment: any,
    @Inject('EmpusaAuthenticationService')
    public authService: EmpusaAuthenticationService | any,
    private formBuilder: FormBuilder,
    private router: Router,
    public dialog: MatDialog,
    public spinnerSrv: SpinnerService,
    private facturaPoseedorControllerService: FacturaPoseedorControllerService,
    private facturaPoseedorEstadosControllerService: FacturaPoseedorEstadosControllerService,
    private poseedorControllerService: PoseedorControllerService,
    private downloadService: DownloadService,
    private documentService: DocumentService,
    private snackBarSrv: SnackbarService,
    private datePipe: DatePipe,
    private formatCurrencyPipe: FormatCurrencyPipe,
    private cvfControllerService: CvfControllerService,
    private facturaCvfControllerService: FacturaCvfControllerService,
    private diccionarioControllerService: DiccionarioControllerService
  ) {
    this.searchForm = this.formBuilder.group({
      gestorResiduos: [{ value: null, disabled: false }],
      idGestor: [{ value: null, disabled: false }, [Validators.pattern('^[0-9]+$'), Validators.maxLength(10)]],
      codigo_documento: [{ value: null, disabled: false }],
      razon_social: [{ value: null, disabled: false }],
      nima_gestor: [{ value: null, disabled: false }],
      numero_autoFactura: [{ value: null, disabled: false }, [Validators.pattern('^[0-9]+$'), Validators.maxLength(10)]],
      fecha_autoFactura: [{ value: null, disabled: false }],
      numero_facturaGestor: [{ value: null, disabled: false }, [Validators.maxLength(20)]],
      fecha_facturaGestor: [{ value: null, disabled: false }],
      estado: [{ value: null, disabled: false }],
      orden: [{ value: null, disabled: false }],
      tipoOrden: [{ value: null, disabled: false }],
    });
  }

  ngOnInit() {
    this.comboEstados();
    this.comboOrden();
    // this.getPoseedores();
  }

  checked(event: any) { }

  renderPage(event: number) {
    this.pageNumber = event;
    if (this.flagSearch) {
      this.searchData();
    }
  }

  exportarExcel() {
    const { backendFilter, page, size } = this.getBackendFilter();
    this.facturaCvfControllerService
    .exportCvfCSV(backendFilter, 'response')
    .subscribe((res) => {
      this.downloadService.exportModal();
    });
  }

  clearSearcher() {
    this.searchForm.reset();
    this.flagSearch = false;
    this.gridArray = [];
  }

  toggleFiltros(): void {
    this.mostrarFiltros = !this.mostrarFiltros;
  }

  quitarFiltro(filtro: { label: string; campo: string; value?: any }): void {
    if (filtro.value !== undefined) {
      const current = this.searchForm.get(filtro.campo)?.value as any[];
      if (Array.isArray(current)) {
        const updated = current.filter((v) =>
          v?.id !== undefined && filtro.value?.id !== undefined ? v.id !== filtro.value.id : v !== filtro.value
        );
        this.searchForm.get(filtro.campo)?.setValue(updated.length ? updated : null);
      }
    } else {
      this.searchForm.get(filtro.campo)?.reset();
    }
    //this.searchData(true);
  }

  get filtrosAplicados(): { label: string; campo: string; value?: any }[] {
    const filtros: { label: string; campo: string; value?: any }[] = [];

    const idGestor = this.searchForm.get('idGestor')?.value;
    if (idGestor) filtros.push({ label: `${idGestor}`, campo: 'idGestor' });

    const doc = this.searchForm.get('codigo_documento')?.value;
    if (doc?.trim()) filtros.push({ label: doc.trim(), campo: 'codigo_documento' });

    const razon = this.searchForm.get('razon_social')?.value;
    if (razon?.trim()) filtros.push({ label: razon.trim(), campo: 'razon_social' });

    const nima = this.searchForm.get('nima_gestor')?.value;
    if (nima) filtros.push({ label: ` ${nima}`, campo: 'nima_gestor' });

    const numPrefactura = this.searchForm.get('numero_autoFactura')?.value;
    if (numPrefactura) filtros.push({ label: ` ${numPrefactura}`, campo: 'numero_autoFactura' });

    const fechaPrefactura = this.searchForm.get('fecha_autoFactura')?.value;
    if (fechaPrefactura) filtros.push({ label: ` ${moment(fechaPrefactura).format('DD/MM/YYYY')}`, campo: 'fecha_autoFactura' });

    const numFactura = this.searchForm.get('numero_facturaGestor')?.value;
    if (numFactura) filtros.push({ label: ` ${numFactura}`, campo: 'numero_facturaGestor' });

    const fechaFactura = this.searchForm.get('fecha_facturaGestor')?.value;
    if (fechaFactura) filtros.push({ label: ` ${moment(fechaFactura).format('DD/MM/YYYY')}`, campo: 'fecha_facturaGestor' });

    const estados = this.searchForm.get('estado')?.value as any[];
    if (estados?.length) {
      estados.forEach((est: any) => {
        filtros.push({ label: est.descripcion ?? String(est), campo: 'estado', value: est });
      });
    }
const ordenes = this.searchForm.get('orden')?.value;
    if (Array.isArray(ordenes) && ordenes.length) {
      ordenes.forEach((ordenCodigo: any) => {
        filtros.push({
          label: `Orden: ${String(ordenCodigo)}`,
          campo: 'orden',
          value: ordenCodigo,
        });
      });
    } else if (ordenes) {
      filtros.push({ label: `Órdenes: ${String(ordenes)}`, campo: 'orden' });
    }

    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    if (tipoOrden) {
      const label =
        tipoOrden === 'ASC'
          ? 'Ascendente'
          : tipoOrden === 'DESC'
          ? 'Descendente'
          : String(tipoOrden);
      filtros.push({ label: `Tipo orden: ${label}`, campo: 'tipoOrden' });
    }
    return filtros;
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.searchForm.controls[controlName].hasError(errorName) &&
      this.searchForm.controls[controlName].touched
    );
  }

  // getPoseedores() {
  //   if (this.authService.user?.roleEntities?.length > 0) {
  //     const poseedorIds = this.authService.user?.roleEntities
  //       .filter((poseedorRol: any) => poseedorRol.type === 'POSEEDOR')
  //       .flatMap((poseedorRol: any) => {
  //         if(poseedorRol.entity == null || poseedorRol.entity == undefined){
  //           return [];
  //         }else if (Array.isArray(poseedorRol.entity)) {
  //           return poseedorRol.entity;
  //         } else {
  //           return [poseedorRol.entity];
  //         }
  //       });
  //     const filter: PoseedorFilterDTO = {
  //       id: poseedorIds,
  //     };
  //     this.spinnerSrv.loadingShow();
  //     this.poseedorControllerService
  //       .findAll5(filter, { page: 0, size: 100 })
  //       .subscribe({
  //         next: (response: any) => {
  //           this.poseedorArray = response?.datos;
  //           this.spinnerSrv.loadingHide();
  //         },
  //         error: (err) => {
  //           console.log(err);
  //           this.spinnerSrv.loadingHide();
  //         },
  //       });
  //   }
  // }

  private getBackendFilter() {
    const {
      gestor,
      idGestor,
      codigo_documento,
      razon_social,
      nima_gestor,
      numero_autoFactura,
      fecha_autoFactura,
      numero_facturaGestor,
      fecha_facturaGestor,
      estado
    } = this.searchForm.controls;

    const formatDate = (date: any) => {
      if (date && date.value) {
        return moment(new Date(date.value)).format('DD/MM/YYYY');
      }
      return undefined;
    };
 let fechaAutofactura;
  let fechaFactura;
 if(this.searchForm.get('fecha_autoFactura')?.value){
    fechaAutofactura = moment(
              new Date(this.searchForm.get('fecha_autoFactura')?.value)
            ).format('YYYY-MM-DD')
    }
    if(this.searchForm.get('fecha_facturaGestor')?.value){
      fechaFactura= moment(
               new Date(this.searchForm.get('fecha_facturaGestor')?.value)
             ).format('YYYY-MM-DD')
    }

    const backendFilter: any = {
      gestorResiduos: {
        id: idGestor?.value,
        codigoDocumento: codigo_documento?.value,
        razonSocial: razon_social?.value ? razon_social?.value.trim() : undefined,
        nima: nima_gestor?.value,
      },
      numeroAutofactura: numero_autoFactura?.value,
      fechaAutofactura: formatDate(fecha_autoFactura),
      numeroFactura: numero_facturaGestor?.value,
      fechaFactura: formatDate(fecha_facturaGestor),
      estado: estado?.value,
      origen: 'CVF',
    };

    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    const orden = this.searchForm.get('orden')?.value;
    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    return { backendFilter, page, size: this.pageSize, orden, tipoOrden };
  }

  searchData(initPage: boolean = false) {
    if (initPage) {
      this.pageNumber = 0;
    }
    if (this.searchForm.invalid) {
      this.searchForm.markAllAsTouched();
      return;
    }
    const { backendFilter, page, size, orden, tipoOrden } = this.getBackendFilter();
    this.spinnerSrv.loadingShow();
    this.facturaCvfControllerService
      .findAll14(backendFilter, {
        page: page,
        size: size,
        sort: ['id,desc'],
      },
        orden,
        tipoOrden)
      .subscribe({
        next: (data: PageDTOFacturaDTO) => {
          if (data) {
            this.spinnerSrv.loadingHide();
            this.flagSearch = data.datos?.length != 0 ? true : false;
            this.gridArray = this.canAccessAll(data.datos) ?? [];
            this.recordsTotal = data.paginacion?.totalElements ?? 0;
            this.totalSearch = this.gridArray.length;
          }
        },
        error: (error: any) => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  onItemsPerPageChange() {
    this.pageSize = this.selectedItemsPerPage;
    this.searchData();
  }

  // action(element: any) {
  //   if (element.nameButton == 'view') {
  //     this.openModalDetail(element);
  //   } else if (element.nameButton == 'delete') {
  //     this.confirmacionEliminar(element);
  //   } else if (element.nameButton == 'add_invoice') {
  //     this.openModalUploadInvoice(element);
  //   } else if (element.nameButton == 'donwload_invoice') {
  //     this.descargar(element.documento);
  //   } else if (element.nameButton == 'donwload_self_invoice') {
  //     this.descargar(element.documentoAutofactura);
  //   } else if (element.nameButton == 'accept_invoice') {
  //     this.confirmacionCambioEstado(element.id, 3);
  //   } else if (element.nameButton == 'donwload_pre_invoice-detail') {
  //     this.descargarDetallePrefacturacion(element);
  //   } else if (element.nameButton == 'reject_invoice') {
  //     this.openModalMotivoRechazo(element);
  //   } else if (element.nameButton == 'registrate') {
  //     this.registrarFactura(element);
  //   }
  // }
  action(element: any) {
    if (element.nameButton == 'view') {
      this.openModalDetail(element);
    } else if (element.nameButton == 'delete') {
      this.confirmacionEliminar(element);
    } else if (element.nameButton == 'add_invoice') {
      this.openModalUploadInvoice(element);
    } else if (element.nameButton == 'download_invoice') {
      this.descargar(element.documento);
    } else if (element.nameButton == 'download_self_invoice') {
      this.descargar(element.documentoAutofactura);
    } else if (element.nameButton == 'accept_invoice') {
      this.confirmacionCambioEstado(element.id, 3);
    } else if (element.nameButton == 'reject_invoice') {
      this.openModalMotivoRechazo(element);
    }else if (element.nameButton == 'descargarDetalle') {
      this.exportarDetalle(element);
    }
  }
  confirmacionEliminar(element?: any): void {
    Swal.fire({
      text: `¿Desea eliminar la prefactura?`,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.eliminarInvoices(element);
      }
    });
  }

  eliminarInvoices(element?: any) {
    if (element?.id) {
      this.spinnerSrv.loadingShow();
      this.facturaPoseedorControllerService.deleteById5(element.id).subscribe({
        next: () => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            `El registro de factura se ha eliminado correctamente`,
            'success'
          );
          this.gridArray = this.gridArray.filter(
            (objeto) => objeto.id !== element.id
          );
          this.flagSearch = this.gridArray.length != 0 ? true : false;
        },
        error: (err: { message: any }) => {
          this.spinnerSrv.loadingHide();
        },
      });
    }
  }
  comboOrden() {
    this.diccionarioControllerService.listarElementos(['ORDEN_CVF_PREFACTURAS_FACTURAS_BUSQUEDA']).subscribe({
      next: (data: any) => {
        this.orden = data['ORDEN_CVF_PREFACTURAS_FACTURAS_BUSQUEDA'] ?? [];
      },
      error: () => { },
    });
  }
  comboEstados() {
    this.facturaPoseedorEstadosControllerService.findAll11().subscribe({
      next: (data: Array<FacturaEstadoDTO>) => {
        this.estadoArray = data!;
      },
      error: () => { },
    });
  }

  public rightHolder(controlName: string) {
    let cl2 = '';
    if (
      (this.searchForm.controls[controlName]?.touched ||
        this.searchForm.controls[controlName]?.dirty) &&
      this.searchForm.controls[controlName]?.errors
    ) {
      cl2 = 'error-focus-input';
    } else {
      cl2 = 'success-focus-input';
    }
    return `${cl2}`;
  }

  showClearButton(formName: string): boolean {
    return this.searchForm.get(formName)?.value !== null;
  }

  clearSelection(event: Event, formName: string) {
    event.stopPropagation();
    this.searchForm.get(formName)?.setValue(null);
  }

  openModalUploadInvoice(element?: any): void {
    const dialogRef = this.dialog.open(
      HoldersCvfInvoiceNewDocumentDialogComponent,
      {
        width: '650px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          itemOpen: element,
        },
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.searchData();
      }
    });
  }

  openModalDetail(element?: any): void {
    const dialogRef = this.dialog.open(
      HoldersCvfInvoicesDialogComponent,
      {
        width: '950px',
        maxWidth: '98%',
        maxHeight: '95vh',
        data: element,
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.searchData();
      }
    });
  }

  descargar(documento: any) {
    this.spinnerSrv.loadingShow();
    this.documentService.descargarDocumento(documento.id).subscribe({
      next: (response) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Se ha descargado el documento correctamente',
          'success'
        );
        this.downloadService.downloadBlob(response, documento.nombre);
      },
      error: () => {
        this.spinnerSrv.loadingHide();
      },
    });
  }

  descargarDetallePrefacturacion(documento: any) {
    //this.spinnerSrv.loadingShow();
    this.facturaPoseedorControllerService.prefacturaDetalle(documento.id, 'response')
      .subscribe((res: any) => {
        const filename = this.downloadService.getFileName(
          res.headers,
          'Prefacturación.xlsx'
        );
        this.downloadService.downloadBlob(res.body!, filename!);
      });
  }

  registrarFactura(item: any) {
    this.spinnerSrv.loadingShow();
    this.facturaPoseedorControllerService.registrarFactura(item.id)
      .subscribe({
        next: (res: any) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            `La factura se ha registrado correctamente`,
            'success'
          );
          this.searchData();
        },
        error: (err: { message: any }) => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  confirmacionCambioEstado(id?: any, estadoId?: any): void {
    Swal.fire({
      text: `¿Desea cambiar el estado del registro por Aceptada por Envalora?`,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.actualizarEstado(id, estadoId);
      }
    });
  }

  actualizarEstado(id?: any, estadoId?: any) {
    if (id && estadoId) {
      this.spinnerSrv.loadingShow();
      this.facturaPoseedorControllerService
        .actualizarEstado(id, estadoId)
        .subscribe({
          next: () => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar(
              `El registro de factura se ha actualizado correctamente`,
              'success'
            );
            this.searchData();
          },
          error: (err: { message: any }) => {
            this.spinnerSrv.loadingHide();
          },
        });
    }
  }

  canViewResource(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }

  canAccessExport(): boolean {
    return this.authService.can('poseedores-facturas', 'update-exportar');
  }

  canViewRegistrada(): boolean {
    return this.authService.can('poseedores-facturas', 'view-registrada');
  }

  canAccessEnvalora(): boolean {
    return this.canViewResource('PO-ENV-GEST') || this.canViewResource('PO-ENV-CONS');
  }

  canAccessInformeContabilizacion(): boolean {
    return this.authService.can('poseedores-facturas', 'access-informe-contabilizacion');
  }

  canAccessAll(list: any) {
    const resultDelete = this.authService.can('cvf-menu', 'delete');
    const resultUpFactura = this.authService.can(
      'poseedores-facturas',
      'update'
    );
    const resultDownloadAutofactura = this.authService.can(
      'poseedores-facturas',
      'download-autofactura'
    );
    const resultDownloadFactura = this.authService.can(
      'poseedores-facturas',
      'download-factura'
    );
    const resultUpdateAccept = this.authService.can(
      'poseedores-facturas',
      'update-accept'
    );

    const resultReject = this.authService.can(
      'poseedores-facturas',
      'reject-factura'
    );

    const isGestorEnvalora = this.canViewResource('PO-ENV-GEST');
    const isGestor = this.canViewResource('PO-GESTOR');
    const resultRegistrate = this.authService.can(
      'poseedores-facturas',
      'registrar'
    );

    const resultDetail = this.authService.can(
      'poseedores-facturas-detalle',
      'access-all'
    );

    const listPermission = list.map((objeto: any) => {
      const estado1 = objeto.estado && objeto.estado.id === 1; //Pdte Factura
      const estado2 = objeto.estado && objeto.estado.id === 2; //Facturada
      const estado3 = objeto.estado && objeto.estado.id === 3; //Aceptada
      const estado4 = objeto.estado && objeto.estado.id === 4; //Rechazada

      let formattedDate =
        objeto.fechaFactura != null
          ? this.datePipe.transform(objeto.fechaFactura, 'dd/MM/yyyy')
          : null;
      objeto.fechaMFactura = formattedDate;

      let formattedDateM =
        objeto.fechaAutofactura != null
          ? this.datePipe.transform(objeto.fechaAutofactura, 'dd/MM/yyyy')
          : null;
      objeto.fechaMAutofactura = formattedDateM;

      return {
        ...objeto,
        canAccessView: isGestor || isGestorEnvalora,
        canAccessDelete: isGestorEnvalora && estado1,
        canAccessUpInvoice: isGestor && (estado1 || estado4),
        canAccessDonwloadInvoice: (isGestor || isGestorEnvalora) && (estado2 || estado3),
        canAccessDonwloadSelfInvoice: isGestor || isGestorEnvalora,
        canAccessAcceptInvoice: (isGestorEnvalora && estado2),
        canRejectInvoice: isGestorEnvalora && estado2,
      };
    });

    return listPermission;
  }

  onlyNumberKey(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete', 'Control'];

    if (event.ctrlKey && (event.key === 'c' || event.key === 'v')) return;

    // Permitir números y teclas adicionales definidas
    if (!/^[0-9]$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
    onlyNumberCommaKey(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete', 'Control'];

    if (event.ctrlKey && (event.key === 'c' || event.key === 'v')) return;

    // Permitir números y teclas adicionales definidas
    if (!/^[0-9;]$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
  openModalMotivoRechazo(item: any) {
    const dialogRef = this.dialog.open(
      HoldersCvfInvoiceRejectDialogComponent,
      {
        width: '750px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          info: item,
        },
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.searchData();
      }
    });
  }

  openModalAccounting(element?: any): void {
    const dialogRef = this.dialog.open(
      HoldersInvoiceAccountingDialogComponent,
      {
        width: '650px',
        maxWidth: '95%',
        maxHeight: '95vh',
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.searchData();
      }
    });
  }

  exportarDetalle(item : any){
    this.spinnerSrv.loadingShow()
    this.facturaCvfControllerService
      .prefacturaDetalle1(item?.id, 'response')
      .subscribe((res, ) => {
        const filename = this.downloadService.getFileName(
          res.headers,
          'Detalle_prefactura_cvf.xlsx'
        );

        this.downloadService.downloadBlob(res.body!, filename!);
        this.spinnerSrv.loadingHide();
      }); 

     }

}
